var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import cx from 'classnames';
import { createPortal } from 'react-dom';
import { Children, useRef } from 'react';
import useMeasure from 'react-use-measure';
import { withAliases } from '../../../../infra/ui/utils/with-aliases';
import styles from './styles.module.scss';
import { useClickOutside } from '../../../../infra/small-tools/use-click-outside';
import { useDropdownPosition } from '../../../../infra/dls/hooks/use-dropdown-position';
var VerticalDivider = function () {
    return _jsx("div", { className: styles['vertical-divider'] });
};
var ActionBarRow = function (_a) {
    var children = _a.children;
    var truthyChildren = Children.toArray(children).filter(Boolean);
    return (_jsx("div", { className: styles.row, children: Children.map(truthyChildren, function (child, index) { return (_jsxs(_Fragment, { children: [child, index < Children.count(truthyChildren) - 1 && _jsx(VerticalDivider, {})] })); }) }));
};
var ActionBarRowSection = function (_a) {
    var children = _a.children;
    return _jsx("div", { className: styles['row-section'], children: children });
};
var JustActionBar = function (_a) {
    var _b;
    var _c;
    var children = _a.children, _d = _a.alignment, alignment = _d === void 0 ? 'center' : _d, _e = _a.excludeFromOutsideClick, excludeFromOutsideClick = _e === void 0 ? [] : _e, _f = _a.compensateScroll, compensateScroll = _f === void 0 ? false : _f, props = __rest(_a, ["children", "alignment", "excludeFromOutsideClick", "compensateScroll"]);
    var actionBarEl = useRef(null);
    var _g = useMeasure(), measureRef = _g[0], bounds = _g[1];
    var mountNode = (_c = props === null || props === void 0 ? void 0 : props.getMountNode) === null || _c === void 0 ? void 0 : _c.call(props);
    var setRefs = function (node) {
        actionBarEl.current = node;
        measureRef(node);
    };
    useClickOutside(actionBarEl, function () {
        if (props.onClose && props.visible) {
            props.onClose();
        }
    }, __spreadArray(['data-action-bar-content'], excludeFromOutsideClick, true));
    var isAttached = 'getMountNode' in props;
    var dropdownPosition = useDropdownPosition(props.visible, mountNode, bounds, 'top', alignment, 'force-top', false, compensateScroll);
    if (!isAttached) {
        return (_jsx("div", { className: cx(styles.container, props.className, (_b = {},
                _b[styles['container-relative-to-parent']] = props.relativeToParent,
                _b[styles['container-relative-to-parent--hidden']] = props.relativeToParent && !props.visible,
                _b)), ref: setRefs, children: children }));
    }
    if (!mountNode || !dropdownPosition) {
        return null;
    }
    return createPortal(_jsx("div", { className: cx(styles.container, styles['container-attached'], props.className), style: dropdownPosition, ref: setRefs, onFocus: function () { var _a; return (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props); }, onBlur: function () { var _a; return (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props); }, "data-action-bar-content": true, children: children }), document.getElementById('app-modals-portal'));
};
export var ActionBar = withAliases(JustActionBar, {
    Row: ActionBarRow,
    RowSection: ActionBarRowSection,
});
